import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MainBudgetingReportCategoryLine  {
    _originalTypeClassName = "zERP.BO.MainBudgetingReportCategoryLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MainBudgetingReportCategoryLine.translate = translateService;
}
this.Code = null;
this.DescriptionName = null;
this.BudgetingAmount2 = null;
this.ActualAmount2 = null;
this.UsedPercentage2 = null;
this.BudgetingDifference = null;
this.BudgetingAmount1 = null;
this.ActualAmount1 = null;
this.UsedPercentage1 = null;
this.BudgetingAmount = null;
this.ActualAmount = null;
this.UsedPercentage = null;
this.GroupBy = null;
this.AmountAfterAdjustmentIncome = null;
this.AmountAfterAdjustmentExpense = null;
this.MainBudgetingReportCategoryLineKey = null;
this._key = this.MainBudgetingReportCategoryLineKey = 0; 
}

static translate: TranslateService;
_key: any;
Code:any;
DescriptionName:any;
BudgetingAmount2:any;
ActualAmount2:any;
UsedPercentage2:any;
BudgetingDifference:any;
BudgetingAmount1:any;
ActualAmount1:any;
UsedPercentage1:any;
BudgetingAmount:any;
ActualAmount:any;
UsedPercentage:any;
GroupBy:any;
AmountAfterAdjustmentIncome:any;
AmountAfterAdjustmentExpense:any;
private _MainBudgetingReportCategoryLineKey:any;
get MainBudgetingReportCategoryLineKey(): any {
    return this._MainBudgetingReportCategoryLineKey;
  }
set MainBudgetingReportCategoryLineKey(value: any) {
    this._MainBudgetingReportCategoryLineKey = value;
    this._key = value;
  }

static Fill(lines: any,areExpenses: any,categoryCode: any,categoryName: any,adjustments: any): any{let category = new Domain.MainBudgetingReportCategoryLine();
category.GroupBy = (areExpenses ? "ΕΞΟΔΑ" : "ΕΣΟΔΑ");
category.BudgetingAmount2 = 0;
category.ActualAmount2 = 0;
category.UsedPercentage2 = 0;
category.BudgetingDifference = 0;
category.BudgetingAmount1 = 0;
category.ActualAmount1 = 0;
category.UsedPercentage1 = 0;
category.BudgetingAmount = 0;
category.ActualAmount = 0;
category.UsedPercentage = 0;
category.AmountAfterAdjustmentIncome = 0;
category.AmountAfterAdjustmentExpense = 0;
category.Code = categoryCode;
category.DescriptionName = categoryName;
let approvedAdjustments = (Joove.Common.cast(adjustments?.linq?.where((a) => a?.Status == Domain.BudgetStatus.Approved)?.toArray()?.linq?.selectMany((a) => a?.Modifications)?.toArray(), "System.Collections.List"));
let requestedAdjustments = (Joove.Common.cast(adjustments?.linq?.where((a) => a?.Status == Domain.BudgetStatus.Submited)?.toArray()?.linq?.selectMany((a) => a?.Modifications)?.toArray(), "System.Collections.List"));
for (let _iline = 0; _iline < (lines == null ? 0 : lines.length); _iline++) {let line = lines[_iline];category.BudgetingAmount2 = Joove.Common.safeNumber(category?.BudgetingAmount2) + Joove.Common.safeNumber(line?.BudgetingAmount2);category.ActualAmount2 = Joove.Common.safeNumber(category?.ActualAmount2) + Joove.Common.safeNumber(line?.ActualAmount2);category.BudgetingAmount1 = Joove.Common.safeNumber(category?.BudgetingAmount1) + Joove.Common.safeNumber(line?.BudgetingAmount1);category.ActualAmount1 = Joove.Common.safeNumber(category?.ActualAmount1) + Joove.Common.safeNumber(line?.ActualAmount1);category.BudgetingAmount = Joove.Common.safeNumber(category?.BudgetingAmount) + Joove.Common.safeNumber(line?.BudgetingAmount);category.ActualAmount = Joove.Common.safeNumber(category?.ActualAmount) + Joove.Common.safeNumber(line?.ActualAmount);let approvedAdjustmentDetails = approvedAdjustments?.linq?.where((d) => d != null && d?.BudgetItem != null && d?.BudgetItem?.Code == line?.Code)?.toArray();let requestedAdjustmentDetails = requestedAdjustments?.linq?.where((d) => d != null && d?.BudgetItem != null && d?.BudgetItem?.Code == line?.Code)?.toArray();if (areExpenses) {category.AmountAfterAdjustmentExpense = Joove.Common.safeNumber(category?.AmountAfterAdjustmentExpense) + Joove.Common.safeNumber(line?.BudgetingAmount2) + Joove.Common.safeNumber(approvedAdjustmentDetails?.linq?.sum((d) => d?.ApprovedAmount)) + Joove.Common.safeNumber(requestedAdjustments?.linq?.sum((d) => d?.Amount));}else {category.AmountAfterAdjustmentIncome = Joove.Common.safeNumber(category?.AmountAfterAdjustmentIncome) + Joove.Common.safeNumber(line?.BudgetingAmount2) + Joove.Common.safeNumber(approvedAdjustmentDetails?.linq?.sum((d) => d?.ApprovedAmount)) + Joove.Common.safeNumber(requestedAdjustments?.linq?.sum((d) => d?.Amount));}}
category.UsedPercentage2 = (CLMS.Framework.Number.Equal(() => category.BudgetingAmount2, () => 0) ? 0 : Joove.Common.safeNumber(category?.ActualAmount2) / Joove.Common.safeNumber(category?.BudgetingAmount2));
category.UsedPercentage1 = (CLMS.Framework.Number.Equal(() => category.BudgetingAmount1, () => 0) ? 0 : Joove.Common.safeNumber(category?.ActualAmount1) / Joove.Common.safeNumber(category?.BudgetingAmount1));
category.UsedPercentage = (CLMS.Framework.Number.Equal(() => category.BudgetingAmount, () => 0) ? 0 : Joove.Common.safeNumber(category?.ActualAmount) / Joove.Common.safeNumber(category?.BudgetingAmount));
category.BudgetingDifference = (CLMS.Framework.Number.Equal(() => category.BudgetingAmount2, () => 0) ? 0 : (Joove.Common.safeNumber((Joove.Common.safeNumber(category?.BudgetingAmount2) - Joove.Common.safeNumber(category?.BudgetingAmount1))) / Joove.Common.safeNumber(category?.BudgetingAmount2)));
return category;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MainBudgetingReportCategoryLineKey == null || $this.MainBudgetingReportCategoryLineKey == 0;
            }


}